import { useMutation, useQueryClient } from "react-query";

import type { PhysicianMedicalReferral, PutPhysicianMedicalReferralArgs } from "api/schemas/physician";
import { useApiClient } from "api/useApiClient";

import { getPhysicianHandledPatientQueryKey } from "./useGetPhysicianHandledPatient";
import { queryKeyPrefix as handledQueryPrefix } from "./useGetPhysicianHandledPatients";
import { getPhysicianUnhandledPatientQueryKey } from "./useGetPhysicianUnhandledPatient";
import { queryKeyPrefix as unhandledQueryPrefix } from "./useGetPhysicianUnhandledPatients";

export const usePutPhysicianMedicalReferral = (patientId?: number) => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<PhysicianMedicalReferral, Error, PutPhysicianMedicalReferralArgs>(
    args => client.putPhysicianMedicalReferral(args),
    {
      onSuccess: (data, variables) => {
        if (variables.data.status === "accepted" || variables.data.status === "rejected") {
          if (patientId) {
            queryClient.invalidateQueries(getPhysicianHandledPatientQueryKey(patientId));
            queryClient.invalidateQueries(getPhysicianUnhandledPatientQueryKey(patientId));
          }
          queryClient.invalidateQueries(handledQueryPrefix);
          queryClient.invalidateQueries(unhandledQueryPrefix);
        }
      },
    }
  );
};
